<div [formGroup]="form">
  <div class="row">
    <!--Familienname-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.familienname'"
                   [type]="'text'"
                   [control]="form.get('familienname')"
                   label="Familienname:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popFamilienname'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Familiennamen der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Vorname-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.vorname'"
                   [type]="'text'"
                   [control]="form.get('vorname')"
                   label="Vorname(n):"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popVorname'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den/die Vornamen der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein. Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Geschlecht-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.ansprechpartner.geschlecht'"
                    [control]="form.get('geschlecht')"
                    label="Geschlecht:"
                    i18n-label
                    [items]="geschlechtListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popGeschlecht'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Geschlecht der Referenzperson bzw. der Ansprechperson der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Geschlecht der Referenzperson bzw. der Ansprechperson der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Geschlecht der Referenzperson bzw. der Ansprechperson der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier das Geschlecht der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
          </div>
        </app-select>
      </div>
    </div>
  </div>

  <div class="row">
    <!--  Geburtsdatum-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-date [fieldId]="'referenz.ansprechpartner.geburtsdatum'"
                  [type]="'text'"
                  [control]="form.get('geburtsdatum')"
                  label="Geburtsdatum (TT.MM.JJJJ):"
                  i18n-label
                  [fixDateEnabled]="true"
                  [fixDateType]="'past'"
                  [fixDateUnknownReplacement]="'00'"
                  [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                  [saveLastFocusedEnabled]="true"
                  [popOverName]="'popGeburtsdatum'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt - das Geburtsdatum (im Format TT.MM.JJJJ) der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt - das Geburtsdatum (im Format TT.MM.JJJJ) der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt - das Geburtsdatum (im Format TT.MM.JJJJ) der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier das Geburtsdatum (im Format TT.MM.JJJJ) der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein</span>
          </div>
        </app-date>

      </div>
    </div>
    <!-- Geburtsort-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.geburtsort'"
                   [type]="'text'"
                   [control]="form.get('geburtsort')"
                   label="Geburtsort:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popGeburtsort'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt - den Geburtsort der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt - den Geburtsort der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier – falls bekannt - den Geburtsort der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Geburtsort der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!--  Staatsangehoerigkeit-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.ansprechpartner.staatsangehoerigkeit'"
                    [control]="form.get('staatsangehoerigkeit')"
                    label="Staatsangehörigkeit:"
                    i18n-label
                    [items]="staatsangehoerigkeitListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popStaatsangehoerigkeit'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier – falls bekannt - die Staatsangehörigkeit der Referenzperson bzw. der Ansprechperson der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier – falls bekannt - die Staatsangehörigkeit der Referenzperson bzw. der Ansprechperson der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier – falls bekannt - die Staatsangehörigkeit der Referenzperson bzw. der Ansprechperson der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Staatsangehörigkeit der Referenzperson bzw. der Ansprechperson der Referenzorganisation ein.</span>
          </div>
        </app-select>
      </div>
    </div>
  </div>

  <div class="row">
    <!--  Strasse-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.strasse'"
                   [type]="'text'"
                   [control]="form.get('strasse')"
                   label="Straße:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popStrasse'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Straße der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Hausnummer-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.hausnummer'"
                   [type]="'text'"
                   [control]="form.get('hausnummer')"
                   label="Hausnummer:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popHausnummer'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Hausnummer der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>

  <div class="row">
    <!--  PLZ-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.plz'"
                   [type]="'text'"
                   [control]="form.get('plz')"
                   label="Postleitzahl:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popPlz'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die Postleitzahl der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein. Bitte stellen Sie kein Länderkürzel voran.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Ort-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.anschrift.ort'"
                   [type]="'text'"
                   [control]="form.get('ort')"
                   label="Ort:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popOrt'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der Anschrift der Referenzperson oder der Referenzorganisation in Deutschland ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier den Ort der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Land-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-select [fieldId]="'referenz.ansprechpartner.anschrift.land'"
                    [control]="form.get('land')"
                    label="Land:"
                    i18n-label
                    [items]="landListItems"
                    [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                    [saveLastFocusedEnabled]="true"
                    [popOverName]="'popLand'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land der Anschrift der Referenzperson oder der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land der Anschrift der Referenzperson oder der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte wählen Sie hier das Land der Anschrift der Referenzperson oder der Referenzorganisation aus.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier das Land der aktuellen Anschrift der Referenz ein.</span>
          </div>
        </app-select>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Telefon-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.kontaktdaten.telefon'"
                   [type]="'text'"
                   [control]="form.get('telefon')"
                   label="Telefon-/Mobilfunknummer:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popTelefon'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle Telefonnummer der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- E-Mail-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.kontaktdaten.email'"
                   [type]="'text'"
                   [control]="form.get('email')"
                   label="E-Mail:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popEmail'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier die aktuelle E-Mail-Adresse der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Abweichender Nachname-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.abweichendeSchreibweiseNachname'"
                   [type]="'text'"
                   [control]="form.get('abweichendNachname')"
                   label="Abweichende Schreibweise - Nachname(n):"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popAbweichendNachname'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Familiennamens der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Familiennamens der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Familiennamens der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Familiennamens der Referenzperson ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!--  Abweichender Vorname-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.abweichendeSchreibweiseVorname'"
                   [type]="'text'"
                   [control]="form.get('abweichendVorname')"
                   label="Abweichende Schreibweise - Vorname(n):"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popAbweichendVorname'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Vornamens der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Vornamens der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Vornamens der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, die abweichende Schreibweise des Vornamens der Referenzperson ein.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>

  <div class="row">
    <!--  Andere namen-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.andereNamen'"
                   [type]="'text'"
                   [control]="form.get('andereNamen')"
                   label="Andere Namen:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popAndereNamen'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, andere Namen der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, andere Namen der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, andere Namen der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, andere Namen der Referenz ein.</span>
          </div>
        </app-input>
      </div>
    </div>
    <!-- Frueherer Name-->
    <div class="col-md-4">
      <div class="mb-3">
        <app-input [fieldId]="'referenz.ansprechpartner.fruehereNamen'"
                   [type]="'text'"
                   [control]="form.get('fruehereNamen')"
                   label="Frühere Namen:"
                   i18n-label
                   [toUpperCaseEnabled]="true"
                   [assistantServiceEnabled]="appConfig.isAssistantAvailable"
                   [saveLastFocusedEnabled]="true"
                   [popOverName]="'popFruehereNamen'">
          <div>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, frühere Namen der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'MEK' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, frühere Namen der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, frühere Namen der Referenzperson ein.</span>
            <span *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Bitte tragen Sie hier, sofern vorhanden, frühere Namen der Referenzperson ein.</span>
          </div>
        </app-input>
      </div>
    </div>
  </div>
</div>
